/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { postForgotPassword } from "../../services/authServices";
import { handleErrors } from "../../services/handleErrors";
import { SpinnerButtonPrimary } from "../../ui/buttons";
import { Input, InputContainer, Label, LinkContainer, SubTitle, Title } from "../FormLogin/styles";

// import { useAuth } from "../../context/AuthContext";

const FormForgot = ({ onForgot, title, action }) => {
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: async ({ email }) => {
      try {
        // fotgot in server
        const { message, result } = await postForgotPassword({ email });
        result.email = email;
        toast.success(message);
        onForgot(result); // send to parent component
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Este campo es requerido.").email("Este campo debe ser un mail válido"),
    }),
  });

  return (
    <>
      <div>
        <Title>{title}</Title>
        <SubTitle>Ingrese su email</SubTitle>
      </div>
      <form className="theme-form" onSubmit={formik.handleSubmit}>
        <InputContainer>
          <Label className="pt-0">Usuario</Label>
          <Input
            className={formik.errors.email && formik.touched.email ? "form-control error-field" : "form-control"}
            type="email"
            name="email"
            placeholder="Ingrese su email"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
          />
          {formik.errors.email && formik.touched.email && <div className="input-feedback">{formik.errors.email}</div>}
        </InputContainer>
        <div className="form-group  mt-3 mb-0">
          <SpinnerButtonPrimary
            className="btn-block"
            maxHeight="40px"
            padding="20px"
            justifyContent="center"
            isLoading={formik.isSubmitting}
            disabled={formik.isSubmitting}
            type="submit"
          >
            {action}
          </SpinnerButtonPrimary>
        </div>
        <LinkContainer>
          <Link to="/login">Cancelar</Link>
        </LinkContainer>
      </form>
    </>
  );
};

export default FormForgot;
